import React from 'react';
import { cn } from '../../../utils/styles';

type LegendMap = React.HTMLAttributes<HTMLDivElement>;

function LegendMap({ className, ...props }: LegendMap) {
  return (
    <div {...props} className={cn('absolute w-24 h-auto bottom-4 left-64 right-0 m-auto', className)}>
      <div className="w-full h-3 bg-gradient-to-r from-addition5 to-addition6" />
      <div className="flex justify-between items-center text-xs leading-[14px] font-semibold">
        <span>0%</span>
        <span>100%</span>
      </div>
    </div>
  );
}

export default LegendMap;
